import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

class Clinic extends BaseModel {
    @Expose()
    id = "";
    @Expose()
    name = "";
    @Expose()
    location = "";
}

export { Clinic };
